import { render, staticRenderFns } from "./TabEditorView.vue?vue&type=template&id=a6f910fe&"
import script from "./TabEditorView.vue?vue&type=script&lang=ts&"
export * from "./TabEditorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports